import { Component } from '@angular/core';
import { ModalController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../../carta/services';
import { QRServices } from '../../../services/qrServices';
import { ShareXxssPage } from '../../share-xxss/share-xxss';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'popup-finish-create-element',
  templateUrl: 'popup-finish-create-element.html',
})
export class PopupFinishCreateElementPage {
  origin: any;
  url: any;
  element_uid: any;

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public qrServices: QRServices,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public analyticsServices: AnalyticsServices) {
    this.origin = this.navParams.get('origin');
    this.url = this.navParams.get('url');
    this.element_uid = this.navParams.get('element_uid');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  print() {
    this.analyticsServices.trackingExp('imprimir', this.globals.tracking_exp['print_element'], '');
    window.open(this.url, '_blank');
  }

  copy() {
    this.copyToClipboard(this.url);
    let toast = this.toastCtrl.create({
      message: 'Copiado',
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  qr() {
    this.analyticsServices.trackingExp('crear qr', this.globals.tracking_exp['create_qr'], '');
    this.qrServices.generateMenuCartaGR(this.element_uid, this.origin);
  }

  shareRRSS() {
    let profileModal = this.modalCtrl.create(ShareXxssPage, {
      url: this.url
    });
    profileModal.present();
  }

  copyToClipboard(str) {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
  };

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-finish-create-element/popup-finish-create-element.ts